/**
 * Extracts the HTTP status from an error thrown by a generated `@hey-api`
 * client. Those clients throw the parsed error body; the shared error
 * interceptor (`src/api/clients/interceptors.ts`) attaches a numeric `.status`
 * to it, and that is what this reads.
 *
 * Lives in `utils/` rather than next to the query client because callers that
 * branch on a specific status (a 409 conflict, say) need it too.
 */
export function getErrorStatus(error: unknown): number | undefined {
  // A rejected promise can carry anything, including null; only objects can carry a status.
  if (!error || typeof error !== 'object') return undefined;

  if ('status' in error) {
    const { status } = error as { status?: unknown };
    return typeof status === 'number' ? status : undefined;
  }
  return undefined;
}
